import { httpsCallable } from "firebase/functions";
import { cloudFunctions } from "./getFunctions";
import {
  ActualizarUsuarioDeEmpresa,
  CloudFunctionResponse,
  CallablesGeneral
} from "@fixeduy/restaurantestypes";

const actualizarUsuarioDeEmpresa = async (
  data: ActualizarUsuarioDeEmpresa
): Promise<CloudFunctionResponse> => {
  const run = httpsCallable<CallablesGeneral, CloudFunctionResponse>(
    cloudFunctions,
    "callablesGenerales"
  );
  const result = await run({
    func: "actualizarUsuarioDeEmpresa",
    params: data
  });
  return result.data;
};

export { actualizarUsuarioDeEmpresa };
